import Head from 'next/head';
import { infoEmail } from '@/constants/emails';
import { SITE_URL } from '@/lib/seoRoutes';

const policySections = [
  {
    type: 'header',
    html: `
<h1><strong>Privacy Policy</strong></h1>
    `,
  },
  {
    type: 'content',
    html: `
<p>We welcome you to Docmoonlight, our website at <a
                        href="${SITE_URL}">www.docmoonlight.com</a>
                    and/or our iOS and Android Mobile applications (collectively our
                    “Platform”).</p>
                <br>
                <p>In the below Privacy Policy, we inform you about the scope of the
                    processing of your Personal Identifiable
                    Information (“PII”). Docmoonlight proceeds with all data processing
                    procedures (e.g., collection,
                    processing, and transmission) in accordance with the Florida
                    Information Protection Act of 2014 (“FIPA”),
                    California Consumer Privacy Act (“CCPA”) and the subsequent
                    amendments from the California Privacy Rights
                    and Enforcement Act (“CPRA”). As well as the EU\`s General Data
                    Protection Regulation (“GDPR”).</p>
    `,
  },
  {
    type: 'content-section',
    html: `
<h3><strong>Responsible for data processing</strong></h3>
                <p>Responsible for data processing is:</p>
                <p>DOCMOONLIGHT, LLC</p>
                <p>160 W Camino Real #1009</p>
                <p>Boca Raton, FL 33432</p>
                <p>United States</p>
                <p>Web: <a href="${SITE_URL}">www.docmoonlight.com</a></p>
                <p>E-Mail: <a href="mailto:${infoEmail}">${infoEmail}</a>
                </p>
    `,
  },
  {
    type: 'content-section',
    html: `
<h3><strong>Definitions</strong></h3>
                <p>For the purposes of this Privacy Policy:</p>
                <ul>
                    <li>Account means a unique account created for You to access our Service
                        or parts of our Service.</li>
                    <li>Affiliate means an entity that controls, is controlled by or is
                        under common control with a party, where
                        "control" means ownership of 50% or more of the shares, equity
                        interest or other securities entitled to vote
                        for election of directors or other managing authority.</li>
                    <li>Application refers to Docmoonlight, the software program provided by
                        the Company.</li>
                    <li>Company (referred to as either "the Company", "We", "Us" or "Our" in
                        this Agreement) refers to Docmoonlight.
                    </li>
                    <li>Country refers to: Florida, United States</li>
                    <li>Device means any device that can access the Service such as a
                        computer, a cellphone or a digital tablet.
                    </li>
                    <li>Personal Data is any information that relates to an identified or
                        identifiable individual.</li>
                    <li>Service refers to the Application.</li>
                    <li>Service Provider means any natural or legal person who processes the
                        data on behalf of the Company. It
                        refers to third-party companies or individuals employed by the
                        Company to facilitate the Service, to provide
                        the Service on behalf of the Company, to perform services related to
                        the Service or to assist the Company in
                        analyzing how the Service is used.</li>
                    <li>Usage Data refers to data collected automatically, either generated
                        by the use of the Service or from the
                        Service infrastructure itself (for example, the duration of a page
                        visit).</li>
                    <li>You means the individual accessing or using the Service, or the
                        company, or other legal entity on behalf of
                        which such individual is accessing or using the Service, as
                        applicable.</li>
                </ul>
    `,
  },
  {
    type: 'content-section',
    html: `
<h3><strong>What is PII?</strong></h3>
                <p>PII is any information relating to personal or material circumstances
                    that relates to an identified or identifiable
                    individual. This includes, for example, your name, date of birth, e-mail
                    address, postal address, or telephone number as
                    well as online identifiers such as your IP address. In contrast,
                    information of a general nature that cannot be used to
                    determine your identity is not PII. This includes, for example, the
                    number of users of a website.</p>
    `,
  },
  {
    type: 'content-section',
    html: `
<h3><strong>What is processing?</strong></h3>
                <p>"Processing" means any operation or set of operations which is performed
                    upon PII, whether or not by automatic means.
                    The term is broad and covers virtually any handling of data.
                </p>
    `,
  },
  {
    type: 'content-section',
    html: `
<h3><strong>General information on data processing</strong></h3>
                <p>In the course of our business and platform operations, we process data in
                    our California based headquarters and this
                    data is generally transferred to our Amazon (AWS) S3 server in Amazon’s
                    RDS Database. We also use AWS for the provision
                    of our website, which means that processes all data in connection with
                    the operation of our website on our behalf. The
                    legal basis for the data processing is our legitimate interest in
                    providing our platform.</p>
                <p>All PII that we obtain from you via the platform will only be processed
                    for the purposes described in more detail below.
                    This is done within the framework of the respective legal regulations
                    mentioned or only with your consent. In
                    particular, the above-mentioned provisions specify when data processing
                    is permitted. As such, we collect PII if:
                </p>

                <ul>
                    <li>you have given your consent,</li>
                    <li>the data is necessary for the fulfillment of a contract /
                        pre-contractual measures,</li>
                    <li>the data is necessary for the fulfillment of a legal obligation or
                    </li>
                    <li>the data is necessary to protect the legitimate interests of our
                        company, provided that your interests are not
                        overridden.
                    </li>
                </ul>
                <p>We process and store your PII only for the period of time required to
                    achieve the respective processing purpose or for
                    as long as a legal retention period (in particular Florida’s commercial
                    and tax law) exists. Once the purpose has been
                    achieved or the retention period has expired, the corresponding data is
                    routinely deleted.
                </p>
    `,
  },
  {
    type: 'content-section',
    html: `
<h3 style="text-align: center; margin-bottom: 16pt;"><strong>Processing of
                        Automatically
                        Collected Data</strong></h3>
                <p><em>a) Collection of access data and log files</em></p>
                <p>We also collect data on every access to our website. The access data
                    includes the name of the website accessed,
                    file, date and time of access, amount of data transferred, notification
                    of successful access, browser type and
                    version, the user's operating system, referrer URL (the previously
                    visited page), IP address and the requesting
                    provider.</p>
                <p>Log file information is stored for security reasons (e.g., for the
                    clarification of abuse or fraud) for a maximum
                    of 7 days and then deleted. Data whose further storage is necessary for
                    evidentiary purposes is exempt from
                    deletion until the respective incident is finally clarified. The legal
                    basis for the data processing is our
                    legitimate interest in providing an appealing website.</p>

                <p><em>b) Use of cookies</em></p>
                <p>To improve the services provided on the website, we use cookies that
                    collect information about your usage behavior.
                    Cookies are files that your web browser stores on your hard drive when
                    you visit a website. Cookies may, under certain
                    circumstances, personally identify you either directly (for example,
                    with an e-mail address) or indirectly (for example,
                    with a unique identification code of a cookie, an IP address or the
                    identification code of a device). The data stored
                    may include the pages you visit, the date and time of your visit, and
                    other tracking information. For more information,
                    please refer to our Cookie Policy.
                </p>

                <p><em>c) Downloading the APP</em></p>
                <p>
                    The APP can be downloaded from the "Google Playstore" a service offered
                    by Google Inc, 1600 Amphitheatre Parkway
                    Mountain View, CA 94043, US, if you are resident outside the EU and
                    Google Ireland Limited, Gordon House, Barrow
                    Street, Dublin 4, Ireland if you are a resident within the EU, or the
                    Apple App service "App Store" a service of
                    Apple Inc., 1 Infinite Loop, Cupertino, CA 95014, US, if you are
                    resident outside the EU and Apple Distribution
                    International Ltd, Hollyhill Industrial Estate, Hollyhill Ln,
                    Knocknaheeney, Cork, Ireland, if you are a resident
                    within the EU, to install our APP. Downloading it may require prior
                    registration with the respective App store
                    and/or installation of the respective App store software.
                </p>
                <p><em>d) Installing the APP</em></p>

                <p>
                    As far as we are aware, Google collects and processes the following
                    data: License check, network access, network
                    connection, WLAN connections, and location information. However, it
                    cannot be ruled out that Google also transmits
                    the information to a server in a third country. We cannot influence
                    which PII Google processes with your
                    registration and the provision of downloads in the respective App store
                    and App store software. The responsible
                    party in this respect is solely Google as the operator of the Google
                    Play Store.

                    As far as we are aware, Apple collects and processes the following data:
                    device identifiers, IP addresses, location
                    information, it cannot be excluded that Apple also transmits the
                    information to a server in a third country. This
                    could in particular be Apple Inc. One Apple Park Way, Cupertino,
                    California, USA, 95014. We cannot influence which
                    PII Apple processes with your registration and the provision of
                    downloads in the respective app store and app store
                    software. The responsible party in this respect is solely Apple as the
                    operator of the Apple App Store.
                </p>
                <p><em>e) Device information</em></p>

                <p>
                    Google and Apple may collect information from and about the device(s)
                    you use to access the APP, including hardware
                    and software information such as IP address, device ID and type,
                    device-specific and APP settings and properties,
                    APP crashes, advertising IDs (AAID), information about your wireless and
                    mobile network connection such as your
                    service provider and signal strength; information about device sensors
                    such as accelerometer, gyroscope, and
                    compass.
                </p>
    `,
  },
  {
    type: 'content-section',
    html: `
<h3 style="text-align: center; margin-bottom: 16pt;"><strong>Data processing
                        when you use our services</strong></h3>

                <p><em>a) Contacting us</em></p>
                <p>If you contact us, we process the following data from you for the purpose
                    of processing and handling your request:
                    first name, last name, <a href="mailto:${infoEmail}">e-mail
                        address</a>, and, if applicable, other
                    information if you have provided it, and your message. The legal basis
                    for the data processing is our obligation to
                    fulfill the contract and/or to fulfill our pre-contractual obligations
                    and/or our overriding legitimate interest in
                    processing your request.</p>

                <p><em>b) Profile and account</em></p>
                <p>If you create a user account, we will collect your full name, phone
                    number, email address, Profile Image, address. We
                    also process the information we receive from you as part of the
                    application process, e.g., through your letter of
                    application, CV, references, correspondence, telephone, or verbal
                    details. In addition to your contact details,
                    information about your education, qualifications, work experience and
                    skills is particularly relevant to us.</p>

                <p>Some of the data you choose to provide may be considered non-PII and/or
                    “special” or “sensitive” in certain
                    jurisdictions, for example your racial or ethnic origins, sexual
                    orientation, and religious beliefs. By choosing to
                    provide this data, you consent to our processing of that data.</p>


                <p>Where any PII relates to a third party, you represent and warrant that
                    the PII is up-to-date, complete, and accurate
                    and that you have obtained the third party’s prior consent for our
                    collection, use and disclosure of their PII for
                    the Purposes. You agree that you shall promptly provide us with written
                    evidence of such consent upon demand by us.
                </p>


                <p>Unless otherwise specified the purposes of processing are contractual
                    performance and service, contact requests and
                    communication, office and organizational procedures, administration, and
                    response to requests, visit action
                    evaluation. The legal basis for the data processing is the fulfillment
                    of
                    our contractual obligations and, in
                    individual cases, the fulfillment of our legal obligations as well as
                    your Consent.</p>


                <p>You may withdraw your consent and request us to stop using and/or
                    disclosing your personal and special category data
                    by submitting your request to us in writing to
                    <a>${infoEmail}.</a>
                </p>

                <p><em>c) When using our services</em></p>
                <p>We process the data of our registered users in order to be able to
                    provide our contractual services as well as to
                    ensure the security of our services and to be able to develop it
                    further. This includes in particular our support,
                    correspondence with you, invoicing, fulfillment of our accounting and tax
                    obligations. Your data will not be used by
                    us for automated decision making or profiling, nor will it be shared
                    with third parties. Accordingly, the data is
                    processed on the basis of fulfilling our contractual obligations as well
                    as to fulfil our legal obligations.</p>

                <p>The legal basis for the data processing is the fulfillment of our
                    contractual obligations and, in individual cases,
                    the fulfillment of our legal obligations as well as your consent.</p>

                <p><em>d) Administration</em></p>
                <p>We process data within the scope of administrative tasks as well as
                    organization of our business, financial
                    accounting, and compliance with legal obligations, such as archiving. In
                    doing so, we process the same data that we
                    process in the context of providing our contractual services. The
                    purpose and our interest in the processing lies in
                    the administration, financial accounting, archiving of data, i.e., tasks
                    that serve the maintenance of our business
                    activities, performance of our tasks and provision of our services. The
                    deletion of data with regard to contractual
                    services and contractual communication corresponds to the information
                    mentioned above.</p>

                <p>In this context, we disclose or transmit data to the tax authorities,
                    consultants such as tax advisors or auditors as
                    well as other fee offices and payment service providers. Accordingly,
                    the data is processed on the basis of
                    fulfilling our contractual obligations as well as to </p>

                <p><em>e) Financial Data</em></p>
                <p>Financial Data will be processed via the payment service provider Stripe.
                    Financial Data will solely be processed
                    through the payment system of Stripe. The legal basis for the provision
                    of a payment system is the establishment and
                    implementation of the user contract for the use of the service.</p>

                <p><em>f) Service Notifications</em></p>
                <p>By using our services, you are giving your consent to receiving
                    notifications and messages per email and SMS. Those
                    typically include administrative information about your account and
                    activity. The legal bases are to provide you with
                    our services and your consent.</p>

                <p><em>g) Marketing</em></p>
                <p>Insofar as you have also given us your consent to process your PII for
                    marketing and advertising purposes, we are
                    entitled to contact you for these purposes via the communication
                    channels you have given your consent to.
                </p>

                <p>You may give us your consent in a number of ways including by selecting a
                    box on a form where we seek your permission,
                    or sometimes your consent is implied from your interactions or
                    contractual relationship. Where your consent is implied,
                    it is on the basis that you would have a reasonable expectation of
                    receiving a marketing communication based on your
                    interactions or contractual relationship with us.
                </p>

                <p>Our Marketing generally takes the form of e-mail but may also include
                    other less traditional or emerging channels. These
                    forms of contact will be managed by us, or by our contracted service
                    providers. Every directly addressed marketing sent
                    by us or on our behalf will include a means by which you may unsubscribe
                    or opt out.
                </p>
    `,
  },
  {
    type: 'content-section',
    html: `
<h3><strong>Information Collected while Using the Application</strong></h3>
                <p>While using Our Application, in order to provide features of Our
                    Application, We may collect, with Your prior
                    permission:</p>
                <ul>
                    <li>Information regarding your location</li>
                    <li>Pictures and other information from your Device's camera and photo
                        library</li>
                </ul>
                <p>We use this information to provide features of Our Service, to improve
                    and customize Our Service.</p>
    `,
  },
  {
    type: 'content-section',
    html: `
<h3><strong>Use of Your Personal Data</strong></h3>
                <p>The Company may use Personal Data for the following purposes:</p>
                <ul>
                    <li><b>To provide and maintain our Service</b>, including to monitor the
                        usage of our Service.</li>
                    <li><b>To manage Your Account:</b> to manage Your registration as a user
                        of the Service. The Personal Data You
                        provide can give You access to different functionalities of the
                        Service that are available to You as a
                        registered user.</li>
                    <li><b>For the performance of a contract:</b> the development,
                        compliance and undertaking of the purchase
                        contract for the products, items or services You have purchased or
                        of any other contract with Us through the
                        Service.</li>
                    <li><b>To contact You:</b> To contact You by email, telephone calls,
                        SMS, or other equivalent forms of
                        electronic communication, such as a mobile application's push
                        notifications regarding updates or informative
                        communications related to the functionalities, products or
                        contracted services, including the security
                        updates, when necessary or reasonable for their implementation.</li>
                    <li><b>To provide You with news,</b> special offers and general
                        information about other goods, services and
                        events which we offer that are similar to those that you have
                        already purchased or enquired about unless You
                        have opted not to receive such information.</li>
                    <li><b>To manage Your requests:</b> To attend and manage Your requests
                        to Us.</li>
                    <li><b>For business transfers:</b> We may use Your information to
                        evaluate or conduct a merger, divestiture,
                        restructuring, reorganization, dissolution, or other sale or
                        transfer of some or all of Our assets, whether
                        as a going concern or as part of bankruptcy, liquidation, or similar
                        proceeding, in which Personal Data held
                        by Us about our Service users is among the assets transferred.</li>
                    <li><b>For other purposes:</b> We may use Your information for other
                        purposes, such as data analysis,
                        identifying usage trends, determining the effectiveness of our
                        promotional campaigns and to evaluate and
                        improve our Service, products, services, marketing and your
                        experience.</li>
                </ul>
                <p>We may share Your personal information in the following situations:</p>
                <ul>
                    <li><b>With Service Providers:</b> We may share Your personal
                        information with Service Providers to monitor and
                        analyze the use of our Service, to contact You.</li>
                    <li><b>For business transfers:</b> We may share or transfer Your
                        personal information in connection with, or
                        during negotiations of, any merger, sale of Company assets,
                        financing, or acquisition of all or a portion of
                        Our business to another company.</li>
                    <li><b>With Affiliates:</b> We may share Your information with Our
                        affiliates, in which case we will require
                        those affiliates to honor this Privacy Policy. Affiliates include
                        Our parent company and any other
                        subsidiaries, joint venture partners or other companies that We
                        control or that are under common control
                        with Us.</li>
                    <li><b>With business partners:</b> We may share Your information with
                        Our business partners to offer You certain
                        products, services or promotions.</li>
                    <li><b>With other users:</b> when You share personal information or
                        otherwise interact in the public areas with
                        other users, such information may be viewed by all users and may be
                        publicly distributed outside.</li>
                    <li><b>With Your consent:</b> We may disclose Your personal information
                        for any other purpose with Your consent.
                    </li>
                </ul>
                <h4><b>Retention of Your Personal Data</b></h4>
                <ul>
                    <li>
                        <p>The Company will retain Your Personal Data only for as long as is
                            necessary for the purposes set out in
                            this Privacy Policy. We will retain and use Your Personal Data
                            to the extent necessary to comply with
                            our legal obligations (for example, if we are required to retain
                            your data to comply with applicable
                            laws), resolve disputes, and enforce our legal agreements and
                            policies.</p>
                    </li>
                    <li>
                        <p>The Company will also retain Usage Data for internal analysis
                            purposes. Usage Data is generally retained
                            for a shorter period of time, except when this data is used to
                            strengthen the security or to improve the
                            functionality of Our Service, or We are legally obligated to
                            retain this data for longer time periods.
                        </p>
                    </li>
                </ul>
    `,
  },
  {
    type: 'content-section',
    html: `
<h3><b>Duration of data storage</b></h3>
                <p>We only store PII for as long as it is necessary for the purposes for
                    which it is processed or for as long as any
                    consent you have given us has been revoked by you. Insofar as statutory
                    retention obligations must be observed,
                    the storage period for certain data may be up to 10 years, irrespective
                    of the processing purposes.</p>
    `,
  },
  {
    type: 'content-section',
    html: `
<h3><b>Obligation to provide PII</b></h3>
                <p>You are not obliged to provide us with PII. However, depending on the
                    individual case as described above, the
                    provision of certain PII may be necessary for the provision of the
                    services. If you do not provide us with this
                    PII, we may not be able to provide the requested service.</p>
    `,
  },
  {
    type: 'content-section',
    html: `
<h3><b>Do Not Sell</b></h3>
                <p>We do not sell data to third parties. However, we might, making
                    available, transfer, communicate electronically,
                    consumer’s PII by the business to a business affiliated inclusive with a
                    third party but not for monetary but
                    for other valuable consideration.</p>
    `,
  },
  {
    type: 'content-section',
    html: `
<h3><b>Authorizations and Access</b></h3>
                <p>We may request permission to store your APP data including your Internet
                    Connection and Network, Location, Push
                    Notifications of your device. The legal basis for data processing is our
                    legitimate interest and the provision
                    of contractual or pre-contractual measures. You can deny access on your
                    device via the Settings/Notifications/
                    options of your device; however, this means that our APP may not
                    function as intended.</p>
    `,
  },
  {
    type: 'content-section',
    html: `
<h3><b>Push messages</b></h3>
                <p>When you use the app, you will receive so-called push messages from us,
                    even if you are not currently using the
                    App. These are messages that we send you as part of the performance of
                    the contract. You can adjust or stop
                    receiving push messages at any time via the device settings of your
                    device.</p>
    `,
  },
  {
    type: 'content-section',
    html: `
<h3><b>Transfer of PII</b></h3>
                <p>We will not disclose or otherwise distribute your PII to third parties
                    unless this:</p>
                <ul>
                    <li>
                        <p>is necessary for the performance of our services,</p>
                    </li>
                    <li>
                        <p>you have consented to the disclosure,</p>
                    </li>
                    <li>
                        <p>or the disclosure of data is permitted by relevant legal
                            provisions.</p>
                    </li>
                </ul>
                <p>However, we are entitled to outsource the processing of your PII in whole
                    or in part to external service
                    providers acting as processors within the framework of the
                    above-mentioned laws. External service providers
                    support us, for example, in the technical operation and support of the
                    platform, data management, the provision
                    and performance of services, marketing, as well as the implementation
                    and fulfillment of reporting obligations.
                </p>
                <p>The service providers commissioned by us, however, will process your data
                    exclusively in accordance with our
                    instructions and we remain in accordance with the above-mentioned laws
                    responsible for the protection of your
                    data. Doing so we always make sure that service providers commissioned
                    by us are carefully selected, follow
                    strict contractual regulations, technical and organizational measures,
                    and additional controls by us.</p>
                <p>We may also disclose PII to third parties if we are legally obliged to do
                    so e.g., by court order or if this is
                    necessary to support criminal or legal investigations or other legal
                    investigations or proceedings at home or
                    abroad or to fulfill our legitimate interests.</p>
    `,
  },
  {
    type: 'content-section',
    html: `
<h3><b>Social Media</b></h3>
                <p>We are active on the social networks. We have no influence on the type
                    and scope of the data processed, the type
                    of processing and use, or the transfer of this data to third parties. In
                    addition, there are no effective
                    control options. By using these services, your PII is collected,
                    transferred, stored, disclosed, and used by the
                    providers...</p>
                <p>If you contact us via social media platforms, you should note that the
                    chat history can neither be deleted by us
                    nor by you. And that, in accordance with the GDPR, the relevant social
                    media platform and we are jointly
                    responsible for the processing of your data and enter into a so-called
                    joint controller agreement...</p>
    `,
  },
  {
    type: 'content-section',
    html: `
<h3><b>Data Security</b></h3>
                <p>Our data processing is subject to the principle that we only process the
                    PII that is necessary for the use of our
                    services. In doing so, we take great care to ensure that your privacy
                    and the confidentiality of all PII are
                    always guaranteed...</p>
                <p>All transmitted data is protected by TLS encryption. Transport Layer
                    Security (TLS) is a protocol used to ensure
                    secure data transmission on the Internet. The public-private key
                    procedure is used here...</p>
                <p>We also use technical and organizational security measures (TOMs)
                    throughout the company to protect the data we
                    manage from you against accidental or intentional manipulation, loss,
                    destruction or against access by
                    unauthorized persons...</p>
                <p>Nonetheless, databases or data sets that include PII may be breached
                    inadvertently or through wrongful intrusion.
                    Upon becoming aware of a data breach, we will notify all affected
                    individuals whose PII may have been
                    compromised...</p>
    `,
  },
  {
    type: 'content-section',
    html: `
<h3><b>Your data subject rights</b></h3>
                <p>Under the FIPA, CCPA and the CPRA amendment, you can exercise the
                    following rights:</p>
                <ul>
                    <li><i>Right to Know/Access</i></li>
                    <li><i>Right to Delete</i></li>
                    <li><i>Right to Opt-out of Sale</i></li>
                    <li><i>Right to Non-Discrimination</i></li>
                    <li><i>Right to Rectification</i></li>
                    <li><i>Right to Limit Use and Disclosure of Sensitive PII</i></li>
                </ul>
                <p>Under the GDPR, you can exercise the following rights:</p>
                <ul>
                    <li><i>Right to information</i></li>
                    <li><i>Right to rectification</i></li>
                    <li><i>Right to object to processing</i></li>
                    <li><i>Right to deletion</i></li>
                    <li><i>Right to information</i></li>
                    <li><i>Right to data portability</i></li>
                    <li><i>Right of objection</i></li>
                    <li><i>Right to withdraw consent</i></li>
                    <li><i>Right to complain to a supervisory authority</i></li>
                    <li><i>Right not to be subject to a decision based solely on automated
                            processing</i></li>
                </ul>
    `,
  },
  {
    type: 'content-section',
    html: `
<h3><b>Updating your information</b></h3>
                <p>If you believe that the information we hold about you is inaccurate or
                    that we are no longer entitled to use it
                    and want to request its rectification, deletion, or object to its
                    processing, please do so by contacting us.</p>
    `,
  },
  {
    type: 'content-section',
    html: `
<h3><b>Withdrawing your consent</b></h3>
                <p>You can revoke consents you have given at any time by contacting us. The
                    legality of the data processing carried
                    out until the revocation remains unaffected by the revocation.</p>
    `,
  },
  {
    type: 'content-section',
    html: `
<h3><b>Access Request</b></h3>
                <p>In the event that you wish to make a Data Subject Access Request, you may
                    inform us in writing of the same. We
                    will respond to requests regarding access and correction as soon as
                    reasonably possible. Should we not be able
                    to respond to your request within thirty (30) days after receiving your
                    request, we will inform you in writing
                    within thirty (30) days of the time by which we will be able to respond
                    to your request. If we are unable to
                    provide you with any PII or to make a correction requested by you, we
                    shall generally inform you of the reasons
                    why we are unable to do so (except where we are not required to do so
                    under the respective legal regulations
                    mentioned above).</p>
    `,
  },
  {
    type: 'content-section',
    html: `
<h3><b>Collection and Use of Children's PII</b></h3>
                <p>Power Rich Sports Inc takes the privacy of children very seriously. We do
                    not knowingly collect PII from children
                    through our website.</p>
    `,
  },
  {
    type: 'content-section',
    html: `
<h3><b>Automated decision-making</b></h3>
                <p>We do not use automated decision-making or profiling.</p>
    `,
  },
  {
    type: 'content-section',
    html: `
<h3><b>Do Not Sell</b></h3>
                <p>We do not sell information that directly identifies you.</p>
    `,
  },
  {
    type: 'content-section',
    html: `
<h3><b>Do-not-track</b></h3>
                <p>Most browsers give you the option to enable a so-called "do-not-track"
                    signal to protect against tracking. Our
                    website does not currently respond to "do-not-track" web browser
                    signals. If we implement this feature in the
                    future, we will describe how in this Privacy Policy. For more
                    information about "Do-not-track," please visit <a
                        href="http://www.allaboutdnt.org">www.allaboutdnt.org</a>
                </p>
    `,
  },
  {
    type: 'content-section',
    html: `
<h3><b>Changes and updates</b></h3>
                <p>We kindly ask you to regularly inform yourself about the content of our
                    Privacy Policy. We will amend our Privacy
                    Policy as soon as changes to the information processing activities we
                    carry out make this necessary. We will
                    inform you as soon as the changes require an act of cooperation on your
                    part (e.g., consent) or other individual
                    notification.</p>
    `,
  },
  {
    type: 'content-section',
    html: `
<h3><b>Concerns and Contact</b></h3>
                <p>If you have any concerns about a possible compromise of your privacy or
                    misuse of your PII on our part, or any
                    other questions or comments, you can contact us.</p>
    `,
  },
  {
    type: 'content-section',
    html: `
<h3><b>Effective Date</b></h3>
                <p>Thursday, January 26, 2023</p>
    `,
  },
  {
    type: 'content-section',
    html: `
<h3><b>Delete Your Personal Data</b></h3>
                <p>You have the right to delete or request that We assist in deleting the
                    Personal Data that We have collected about You.</p>
                <p>You may update, amend, or delete Your information at any time by signing
                    in to Your Account, if you have one, and visiting the account settings
                    section that allows you to manage Your personal information. You may
                    also contact Us to request access to, correct, or delete any personal
                    information that You have provided to Us.</p>
                <p>Please note, however, that We may need to retain certain information when
                    we have a legal obligation or lawful basis to do so.</p>
    `,
  },
  {
    type: 'content-section',
    html: `
<h3><b>Children's Privacy</b></h3>
                <p>Our Service does not address anyone under the age of 13. We do not
                    knowingly collect personally identifiable information
                    from anyone under the age of 13. If You are a parent or guardian and You
                    are aware that Your child has provided Us with
                    Personal Data, please contact Us. If We become aware that We have
                    collected Personal Data from anyone under the age of
                    13 without verification of parental consent, We take steps to remove
                    that information from Our servers.
                </p>
                <p>If We need to rely on consent as a legal basis for processing Your
                    information and Your country requires consent from a
                    parent, We may require Your parent's consent before We collect and use
                    that information.
                </p>
    `,
  },
  {
    type: 'content-section',
    html: `
<h3><b>Managing Your Personal Data</b></h3>
                <h4>Your Right to Delete Personal Data:</h4>
                <p>We recognize your right to delete or request assistance in deleting the
                    personal data we have collected about
                    you. This is part of our commitment to ensuring your data privacy and
                    complying with relevant data protection
                    regulations.</p>

                <h4>How to Delete Your Account and Personal Data:</h4>
                <ol>
                    <li>Log into the App: Access your account by logging in.</li>
                    <li>Access Settings: Navigate to the settings by clicking on the
                        'Settings'
                        icon.</li>
                    <li>Initiate Account Deletion: Select the 'Delete Account' option to
                        initiate the process.</li>
                    <li>Confirm Account Deletion: Read the warning carefully. This action
                        will
                        permanently delete your account and
                        all associated data. Confirm if you wish to proceed.</li>
                </ol>

                <h4>Important Considerations:</h4>
                <ul>
                    <li>Data Retention: While we facilitate the deletion of your data,
                        please be
                        aware that in certain
                        circumstances, we may need to retain specific information to fulfill
                        legal obligations or if we have a
                        lawful basis for doing so.</li>
                    <li>Effect of Deletion: Upon deletion of your account, you will lose
                        access
                        to all services and features tied to
                        the account. This action is irreversible.</li>
                    <li>Update or Amend Information: You can update, amend, or delete your
                        information anytime by accessing the
                        account settings.</li>
                </ul>

                <p>Contact Us: For further assistance or queries regarding managing your
                    personal data, please contact us at <a
                        href="mailto:${infoEmail}">${infoEmail}</a>. Our
                    dedicated team is ready to assist you
                    with any concerns or questions you may have.</p>
    `,
  },
];

const getSectionClassName = (type) => {
  if (type === 'header') return 'policy-header';
  if (type === 'content') return 'policy-content';
  return 'policy-section';
};

function PrivacyPolicy() {
  return (
    <>
      <Head>
        <title>Privacy Policy | DocMoonlight</title>
        <meta
          key='description'
          name='description'
          content='Read the DocMoonlight privacy policy and data handling practices.'
        />
        <meta key='robots' name='robots' content='noindex, follow' />
      </Head>

      <main className='min-h-screen bg-[radial-gradient(circle_at_top_left,rgba(var(--theme-accent-rgb),0.16),transparent_28%),linear-gradient(180deg,var(--theme-page-start)_0%,var(--theme-page-mid)_44%,var(--theme-page-end)_100%)] px-4 py-12 text-[var(--theme-dark)] sm:px-6 lg:px-8'>
        <article className='privacy-policy-content mx-auto max-w-5xl overflow-hidden rounded-[1.75rem] border border-[var(--theme-shadow)] bg-[var(--theme-paper)] p-6 shadow-[0_28px_90px_rgba(20,33,61,0.12)] md:p-10 lg:p-14'>
          {policySections.map((section, index) => (
            <section
              key={'privacypolicy-section-' + index}
              className={getSectionClassName(section.type)}
              dangerouslySetInnerHTML={{ __html: section.html }}
            />
          ))}
        </article>
      </main>

      <style jsx global>{`
        .privacy-policy-content {
          color: var(--theme-dark);
        }

        .privacy-policy-content .policy-header {
          margin-bottom: 2.5rem;
          text-align: left;
        }

        .privacy-policy-content .policy-header h1 {
          margin: 0;
          color: var(--theme-dark);
          font-family: inherit;
          font-size: clamp(2.4rem, 5vw, 4.2rem);
          font-weight: 900;
          letter-spacing: 0;
          line-height: 0.98;
        }

        .privacy-policy-content .policy-content,
        .privacy-policy-content .policy-section {
          margin: 0 0 2.1rem;
          color: var(--theme-dark);
          line-height: 1.7;
          text-align: left;
        }

        .privacy-policy-content .policy-section:last-child {
          margin-bottom: 0;
        }

        .privacy-policy-content h3,
        .privacy-policy-content h4 {
          margin: 2rem 0 0.9rem;
          color: var(--theme-dark);
          font-family: inherit;
          font-size: 1.35rem;
          font-weight: 900;
          line-height: 1.25;
        }

        .privacy-policy-content h4 {
          font-size: 1.12rem;
        }

        .privacy-policy-content p,
        .privacy-policy-content li {
          color: rgba(var(--theme-dark-rgb), 0.78);
          font-family: inherit;
          font-size: 1rem;
          font-weight: 600;
          line-height: 1.8;
        }

        .privacy-policy-content p {
          margin: 0 0 1rem;
        }

        .privacy-policy-content ul,
        .privacy-policy-content ol {
          margin: 0.7rem 0 1.2rem 1.5rem;
          padding: 0;
        }

        .privacy-policy-content li {
          margin-bottom: 0.55rem;
        }

        .privacy-policy-content a {
          color: var(--theme-accent);
          font-family: inherit;
          font-size: inherit;
          font-weight: 900;
          text-decoration: underline;
          text-decoration-thickness: 2px;
          text-underline-offset: 3px;
        }
      `}</style>
    </>
  );
}

export default PrivacyPolicy;
